import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const endPoint = '/discover-provinces';

export default {
  async getDiscoverProvinces(payload) {
    const params = getParamsFormObject(payload);
    const path = `${endPoint}${params}`;
    const response = await axiosClient.get(path);
    return response.data;
  },

  async getDiscoverProvinceDetails(id) {
    const path = `${endPoint}/${id}`;
    const response = await axiosClient.get(path);
    return response.data;
  },

  async updateDiscoverProvince(id, payload) {
    const path = `${endPoint}/${id}`;
    const response = await axiosClient.put(path, payload);
    return response.data;
  },

  async createDiscoverProvince(payload) {
    const path = `${endPoint}`;
    const response = await axiosClient.post(path, payload);
    return response.data;
  },

  async deleteDiscoverProvince(id) {
    const path = `${endPoint}/${id}`;
    const response = await axiosClient.delete(path);
    return response.data;
  },

  async getProvincesName() {
    const path = `${endPoint}/provinces-name`;
    const response = await axiosClient.get(path);
    return response.data;
  },
};
